export default __webpack_public_path__ + "src/assets/images/required/no-result-3FTr.png";